import type { BuildMapLinkParams, LocationDescriptor } from './interfaces';

type WazeQuery = {
  q?: string;
  ll?: string;
};

const WAZE_BASE_URL = 'https://waze.com/ul';

export const buildWazeMapDirectionsLink = ({ destination }: BuildMapLinkParams) => {
  return buildWazeDeepLink({ navigate: true, ...toWazeQuery(destination) });
};

export function buildWazeMapsAddressLink({ address }: { address: string }) {
  return buildWazeDeepLink({ navigate: true, q: address });
}

function toWazeQuery(location: LocationDescriptor): WazeQuery {
  switch (location.type) {
    case 'coords':
      return {
        ll: `${location.latitude},${location.longitude}`,
      };
    case 'address':
      return {
        q: location.address,
      };
    case 'place':
      return {
        q: location.placeId,
      };
    default:
      throw new Error('Unknown location type');
  }
}

function buildWazeDeepLink({ navigate, q, ll }: { navigate: boolean; q?: string; ll?: string }): string {
  const params = new URLSearchParams();

  if (navigate) {
    params.set('navigate', 'yes');
  }

  if (q) {
    params.set('q', q);
  }

  if (ll) {
    params.set('ll', ll);
  }

  return `${WAZE_BASE_URL}?${params.toString()}`;
}
